import { invoicingService } from "./repository";

const resource = "/statistics/provision";

export default {
    /**
     * Get recent provision batches
     * @param {number} count - Number of recent batches to fetch (default 20)
     */
    async getRecentBatches(count = 20) {
        return invoicingService.get(`${resource}/batches/recent`, {
            params: { count }
        });
    },

    /**
     * Get detailed information about a specific batch
     * @param {string} batchId - GUID of the batch
     */
    async getBatchDetails(batchId) {
        return invoicingService.get(`${resource}/batch/${batchId}`);
    },

    /**
     * Get area summary for a specific batch
     * @param {string} batchId - GUID of the batch
     */
    async getBatchAreaSummary(batchId) {
        return invoicingService.get(`${resource}/batch/${batchId}/summary`);
    },

    async downloadSummary(batchId) {
        return invoicingService.get(`${resource}/batch/${batchId}/download/summary`, {
            responseType: "blob"
        });
    },

    async downloadEventIds(batchId) {
        return invoicingService.get(`${resource}/batch/${batchId}/download/event-ids`, {
            responseType: "blob"
        });
    },

    async downloadDetailedReport(batchId) {
        return invoicingService.get(`${resource}/batch/${batchId}/download/detailed-report`, {
            responseType: "blob"
        });
    }
};
